import APIService from "@/services/APIService.js";

export const namespaced = true;

export const state = {
    items: [],
    isUpdating: false
};

export const mutations = {
    ADD_ITEM_TO_CART(state, payload) {
        state.items.push(payload)
    },
    REMOVE_ITEM_FROM_CART(state, id) {
        const itemIndex = state.items.findIndex(item => item.selectedPriceID === id);
        state.items.splice(itemIndex, 1)
    },
    CLEAR_CART(state) {
        state.items = []
    }
};

export const non = {};
export const actions = {
    addItemToCart({ commit }, data) {
        commit('ADD_ITEM_TO_CART', data)
    },
    removeItemFromCart({ commit }, productID) {
        commit('REMOVE_ITEM_FROM_CART', productID)
    },
    clearCart({ commit }) {
        commit('CLEAR_CART')
    },
};
